module.exports = "/images/dashboard_black.svg?c4971f8141d3d0c08e1a55ae52ccf9e3";